import React from "react";

function L99DComponentCode() {
  return (
    <div>
      {/* L99D Resource and Description Image Top and Centered - 4 L99B in a row */}
      <div className="lego l099D legoMargin5">
        <div className="quadLegoContainer">

          {/* L99B Resource and Description Image Top and Centered New */}
          <div className="lego l099B legoMargin5">
            <div className="legoContainer">
              <div className="imgContainer">
                <a href="https://orbit-image-video-bucket.s3.us-east-2.amazonaws.com/pdf/LWC+Sleep+Log.pdf">
                  <img
                      className=""
                      src="https://orbit-image-video-bucket.s3.us-east-2.amazonaws.com/4bc561d6c6a8eef51477822c9cca3015.jpeg"
                  />
                </a>
              </div>
              <div className="contentContainer">
                <p className="descriptionHeader">Sleep Hygiene Made Simple</p>
                <p>Click image or <a
                    href="https://orbit-image-video-bucket.s3.us-east-2.amazonaws.com/pdf/LWC+Sleep+Log.pdf">this
                  link</a> to view.</p>
              </div>
            </div>
          </div>
          {/* End L99B Resource and Description Image Top and Centered New */}

          {/* L99B Resource and Description Image Top and Centered New */}
          <div className="lego l099B legoMargin5">
            <div className="legoContainer">
              <div className="imgContainer">
                <a href="https://orbit-image-video-bucket.s3.us-east-2.amazonaws.com/pdf/LWC+Sleep+Log.pdf">
                  <img
                      className=""
                      src="https://orbit-image-video-bucket.s3.us-east-2.amazonaws.com/4bc561d6c6a8eef51477822c9cca3015.jpeg"
                  />
                </a>
              </div>
              <div className="contentContainer">
                <p className="descriptionHeader">Sleep Hygiene Made Simple</p>
                <p>Click image or <a
                    href="https://orbit-image-video-bucket.s3.us-east-2.amazonaws.com/pdf/LWC+Sleep+Log.pdf">this
                  link</a> to view.</p>
              </div>
            </div>
          </div>
          {/* End L99B Resource and Description Image Top and Centered New */}

          {/* L99B Resource and Description Image Top and Centered New */}
          <div className="lego l099B legoMargin5">
            <div className="legoContainer">
              <div className="imgContainer">
                <a href="https://orbit-image-video-bucket.s3.us-east-2.amazonaws.com/pdf/LWC+Sleep+Log.pdf">
                  <img
                      className=""
                      src="https://orbit-image-video-bucket.s3.us-east-2.amazonaws.com/4bc561d6c6a8eef51477822c9cca3015.jpeg"
                  />
                </a>
              </div>
              <div className="contentContainer">
                <p className="descriptionHeader">Sleep Hygiene Made Simple</p>
                <p>Click image or <a
                    href="https://orbit-image-video-bucket.s3.us-east-2.amazonaws.com/pdf/LWC+Sleep+Log.pdf">this
                  link</a> to view.</p>
              </div>
            </div>
          </div>
          {/* End L99B Resource and Description Image Top and Centered New */}

          {/* L99B Resource and Description Image Top and Centered New */}
          <div className="lego l099B legoMargin5">
            <div className="legoContainer">
              <div className="imgContainer">
                <a href="https://orbit-image-video-bucket.s3.us-east-2.amazonaws.com/pdf/LWC+Sleep+Log.pdf">
                  <img
                      className=""
                      src="https://orbit-image-video-bucket.s3.us-east-2.amazonaws.com/4bc561d6c6a8eef51477822c9cca3015.jpeg"
                  />
                </a>
              </div>
              <div className="contentContainer">
                <p className="descriptionHeader">Sleep Hygiene Made Simple</p>
                <p>Click image or <a
                    href="https://orbit-image-video-bucket.s3.us-east-2.amazonaws.com/pdf/LWC+Sleep+Log.pdf">this
                  link</a> to view.</p>
              </div>
            </div>
          </div>
          {/* End L99B Resource and Description Image Top and Centered New */}

        </div>
      </div>
      {/* L99D Resource and Description Image Top and Centered - 4 L99B in a row */}
    </div>
  );
}

export default L99DComponentCode;
